export enum PdfFileType {
  inboundFax = 'inbound_fax',
  patientAttachment = 'patient_attachment',
}
